
import { useMasterLicenseSettings } from '@/contexts/MasterLicenseSettingsContext';

export const useLogoUrl = () => {
  try {
    // Try to access the context
    const { licenseSettings } = useMasterLicenseSettings();
    return licenseSettings.logoUrl || null;
  } catch (error) {
    // If context is not available, fallback to null
    console.warn('useLogoUrl: MasterLicenseSettingsProvider not found, logo will not be displayed');
    return null;
  }
};
